import { forceLogout, login, logout } from '@redux/actions';
import { createSlice } from '@reduxjs/toolkit';

const initialState: AuthState = {
  token: null,
  account: null,
};

const removeAuth = (state: AuthState) => {
  state.token = null;
  state.account = null;
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(forceLogout, removeAuth)
      .addCase(login.fulfilled, (state, { payload }) => {
        state.token = payload.token;
        state.account = payload.account;
      })
      .addCase(logout.fulfilled, removeAuth);
  },
});

export default authSlice.reducer;
